import Raport from '../../../views/Kurikulum/Raport/Raport.view';

export default Raport;